import { render, staticRenderFns } from "./TabelaDocente.vue?vue&type=template&id=5b934697&"
import script from "./TabelaDocente.vue?vue&type=script&lang=js&"
export * from "./TabelaDocente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports